import React from "react";
import SummaryTooltipCell from "../../../components/common/SummaryTooltipCell";
import TruncatedText from "../../../components/common/TruncatedText";
import RatePlanCodeCell from "./components/RatePlanCodeCell";
import RatePlanCodeHeader from "./components/RatePlanCodeHeader";
import DistributionTypeBadge from "./components/DistributionTypeBadge";
import StatusBadge from "./components/StatusBadge";

export const getColumns = ({
  onToggleExpand,
  onToggleExpandAll,
  allExpanded,
}) => [
  {
    key: "code",
    label: "Rate Code",
    className: "rate-plans-derived-rate-page__col-code",
    headerRender: () => (
      <RatePlanCodeHeader
        onToggleExpandAll={onToggleExpandAll}
        allExpanded={allExpanded}
      />
    ),
    render: (row) => (
      <RatePlanCodeCell row={row} onToggleExpand={onToggleExpand} />
    ),
  },
  {
    key: "name",
    label: "Rate Plan Name",
    className: "rate-plans-derived-rate-page__col-name",
    render: (row) => <TruncatedText text={row.name} />,
  },
  {
    key: "status",
    label: "Status",
    className: "rate-plans-derived-rate-page__col-status",
    render: (row) => <StatusBadge isActive={row.isActive} />,
  },
  {
    key: "pricing",
    label: "% Applied",
    className: "rate-plans-derived-rate-page__col-pricing",
    render: (row) => <TruncatedText text={row.pricing} />,
  },
  {
    key: "derivedFromLabel",
    label: "ARI Source",
    className: "rate-plans-derived-rate-page__col-derived-from",
    render: (row) => <TruncatedText text={row.derivedFromLabel} />,
  },
  {
    key: "exclusiveClients",
    label: "Buyers",
    className: "rate-plans-derived-rate-page__col-buyers",
    render: (row) => <SummaryTooltipCell items={row.exclusiveClients} />,
  },
  {
    key: "distributionType",
    label: "Distribution Type",
    className: "rate-plans-derived-rate-page__col-dist",
    render: (row) => (
      <DistributionTypeBadge
        type={row.distributionType}
        commercialModel={row.commercialModel}
      />
    ),
  },
  {
    key: "cancellationLabel",
    label: "Cxl Policy",
    className: "rate-plans-derived-rate-page__col-cancellation",
    render: (row) => <TruncatedText text={row.cancellationLabel} />,
  },
];
